module.exports = __webpack_public_path__ + "static/media/icon_5.168063aa.png";